import { useNavigate } from "react-router-dom";
import "./forgot_password.css";

export default function ForgotPassword() {
  const navigate = useNavigate();

  return (
    <div className="split-login">
      {/* LEFT */}
      <div className="login-left">
        <div className="left-content">
          <h1>Syrano HRMS</h1>
          <p>Password recovery made secure.</p>

          <div className="illustration">
            <img src="/images/login.svg" alt="illustration" />
          </div>

        
         <div className="powered-by">
  <span>Powered by</span>
  <span className="powered-by-badge">
    <img src="/images/syran_logo2.png" alt="Syran Innovations logo" className="powered-by-logo" />
  </span>
  <strong>Syran Innovations</strong>
</div>
        </div>
      </div>

      {/* RIGHT */}
      <div className="login-right">
        <div className="login-right-inner">
          <div className="login-form-wrapper">
            <div className="login-form">
              <h2 className="forgot-heading">Forgot Password</h2>

              <div className="admin-notice">
                <div className="admin-notice-icon">i</div>

                <p className="admin-notice-title">
                  Self-service reset isn't available yet
                </p>

                <p className="admin-notice-text">
                  Self-service password reset is currently being rolled out.
                  Until it's live, please contact your system administrator
                  or reach out to our support team to reset your password.
                </p>
                <a
                
                  href="mailto:support@syrano.in"
                  className="login-btn admin-contact-btn"
                >
                  Contact support@syrano.in
                </a>
              </div>

              <div className="login-options centered">
                <span className="forgot-link" onClick={() => navigate("/login")}>
                  Back to Login
                </span>
              </div>
            </div>
          </div>

          {/* FOOTER */}
          <footer className="login-footer">
            <div className="login-footer-divider" />
            <div className="login-footer-row">
              <span>© {new Date().getFullYear()} Syran Innovations. All rights reserved.</span>
              <span className="login-footer-sep">•</span>
              <a href="mailto:support@syrano.in">support@syrano.in</a>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
}